import { CheckCircle2 } from "lucide-react";

import { PRODUCT_NAME } from "@src/shared/brand";

/**
 * Final step for someone who arrived from an invitation email. There is nothing
 * left to verify — receiving the invitation already proved they own the address
 * — so this only confirms which practice they joined.
 */
export function InvitationJoinStep({
  email,
  error,
  practiceName,
}: {
  email?: string;
  error?: string | null;
  practiceName?: string;
}) {
  const displayEmail = email?.trim() || "your email address";
  const displayPractice = practiceName?.trim() || "your practice";

  return (
    <div className="flex w-full max-w-[390px] flex-col items-center rounded-[18px] border border-border bg-background px-7 py-8 text-center shadow-[0_18px_50px_rgba(20,23,26,0.10)]">
      <div className="flex size-[68px] items-center justify-center rounded-full bg-primary/10 text-primary">
        <CheckCircle2 aria-hidden="true" className="size-8" />
      </div>

      <h2 className="mt-5 text-xl font-semibold tracking-[-0.4px] text-foreground">
        You're joining {displayPractice}
      </h2>
      <p className="mt-2 max-w-[300px] text-sm leading-[1.55] text-muted-foreground">
        Your account is ready and{" "}
        <span className="font-medium text-foreground">{displayEmail}</span> is
        already confirmed, because we sent your invitation there.
      </p>

      {error ? (
        <p
          aria-live="polite"
          className="mt-4 max-w-[300px] rounded-lg border border-destructive/25 bg-destructive/10 px-3 py-2 text-sm leading-[1.45] text-destructive"
          role="alert"
        >
          {error}
        </p>
      ) : null}

      <p className="mt-4 max-w-[300px] font-mono text-[10.5px] leading-[1.5] text-muted-foreground">
        Continue to start using {PRODUCT_NAME.singular} with your team.
      </p>
    </div>
  );
}
